import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {routerInstance} from '@aofl/router';
import {sdoNs} from '../constants-enumerate';
import {deepAssign} from '@aofl/object-utils';
import {SearchParams} from '../search-url-params';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '@modules/i18n';

/**
 * @summary SearchPagination
 * @extends {mapStatePropertiesMixin(i18nMixin(AoflElement))}
 */
@customElement('search-pagination')
class SearchPagination extends mapStatePropertiesMixin(i18nMixin(AoflElement)) {
  /**
   * Creates an instance of SearchPagination.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static is = 'search-pagination';
  @property({type: Number, attribute: false})
  numPages = 3;

  @property({type: Number, attribute: false})
  totalResults = 0;

  @property({type: Array, attribute: false})
  notSelected = [];

  @property({type: Number, attribute: false})
  currentPage = 2;

  @property({type: Boolean})
  disabled = false;

  @property({type: Boolean})
  ['disable-routing']

  @property({type: String})
  ['search-namespace'] = sdoNs.GROUP_SEARCH;

  searchTargetUrl = '';

  async pageChange(e) {
    this.disabled = true;
    await this.updateComplete;

    const currentPage = e.detail.pageNumber;
    const searchState = storeInstance.getState()[this['search-namespace']];

    let sortedField = 'name';

    if (typeof searchState.$sort.fields[0] !== 'undefined') {
      sortedField = searchState.$sort.fields[0];
    }

    const paging = currentPage > this.currentPage ? searchState.$next : searchState.$prev;
    const column = searchState.tableConfig.find((item) => item.key === sortedField);
    const lastValue = column?.sortValue ? column.sortValue(paging) : paging[sortedField];
    const lastValues = [lastValue];
    if (sortedField !== 'id') {
      lastValues.push(paging.id);
    }

    const queryObj = deepAssign(searchState.queryObj, 'sort', {
      last_values: lastValues,
      is_forward: currentPage > this.currentPage
    });

    if (this['disable-routing']) {
      storeInstance.commit({namespace: this['search-namespace'], mutationId: 'setQueryObj', payload: queryObj});
      this.dispatchEvent(new CustomEvent('change-page', {
        detail: {queryObj},
        composed: true
      }));
      this.disabled = false;
    } else {
      const searchParams = SearchParams.encode(queryObj);

      try {
        await routerInstance.navigate(`${this.searchTargetUrl}?${searchParams}`, {});
      } catch (e) {
        this.disabled = false;
      } finally {
        const commits = [];
        if (searchState.lastPage) {
          commits.push({
            namespace: this['search-namespace'],
            mutationId: 'setLastPage',
            payload: false
          });
        }
        const state = this.storeInstance.getState();
        const persistentSelection = state[this['search-namespace']].queryObj.persistent_selection;
        if (persistentSelection.length > 0) {
          commits.push({
            namespace: this['search-namespace'],
            mutationId: 'persistentSelection',
            payload: false
          });
        }
        if (commits.length) {
          storeInstance.commit(...commits);
        }
      }
    }
  }

  mapStateProperties() {
    const state = this.storeInstance.getState();

    this.currentPage = state[this['search-namespace']].$pageNumber;
    this.numPages = state[this['search-namespace']].$numPages;
    this.searchTargetUrl = state[this['search-namespace']].searchTargetUrl;
  }
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default SearchPagination;
